module.exports = __webpack_public_path__ + "mobile/img/business1.22892d15.png";